let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a6Naw")).then(() => parcelRequire('5CafV'));